<template>
  <div class="radio-input">
    <div class="form-group">
      <label v-bind:for="field.name" class="col-sm-4 control-label">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <div class="radio" v-for="radioLabel in field.radioLabels">
          <label>
            <input class="radio" v-bind:id="field.name" type="radio" v-bind:value="radioLabel" v-model="field.value" v-bind:name="field.name"/>
            {{ radioLabel }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  ready () {
    this.validateField(this.field.value)
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.validateField(newVal)
    }
  },
  methods: {
    validateField (val) {
      if (val) {
        this.field.dirty = true
        this.field.valid = true
      } else if (this.field.required) {
        this.field.valid = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RadioInput.vue?14bb439e